import { useState, useEffect } from 'react';
import throttle from 'lodash/throttle';

export default (offset = 0, disabled = false) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = throttle(() => {
      let top = window.pageYOffset || document.documentElement.scrollTop;
      setScrolled(top > offset);
    }, 200);

    if (!disabled) {
      window.addEventListener('scroll', onScroll);
    }

    return function cleanup() {
      window.removeEventListener('scroll', onScroll);
    };
  }, [offset, disabled]);

  return scrolled;
};
